import { storeToRefs } from "pinia";
import { useEventStore } from "@/stores/event";

import { useRoute } from "vue-router";
import { computed } from "vue";

export const useEvent = () => {
  const eventStore = useEventStore();
  const route = useRoute();
  const {
    details,
    events,
    media,
    channels,
    defaultChannels,
    tickets,
    isIframe,
    eventsToArtist,
    eventsToArtistInCity,
    eventsToArtistInCountry,
    eventsToArtistPast,
    eventsToVenues,
    eventsRelatedToVenue,
    eventsRelatedToArtist,
    eventsRelatedToEvent,
    configSeatsio,
    minTickets,
    available,
    pair
  } = storeToRefs(eventStore);

  const getEvents = async () => {
    let params = {
      page_size: 100,
      page: 1,
      hb: process.env.VUE_APP_HOUSE_BRAND
    };
    await eventStore.getEvents(params);
  };

  const getEventBySlug = async (slug) => {
    await eventStore.getDetails(slug);
  };

  const getEventsRelatedToVenue = async (data, addAds = false) => {
    let params = {
      // related_to_venue: data.id,
      // TODO: Revisar y poner related
      venue: data.id,
      page_size: data.page_size || 100,
      count: true
    };
    await eventStore.getEventsRelatedToVenue(params);
    if (addAds && eventsRelatedToVenue.value.length > 1) {
      let cardAd = {
        add: {
          wegow_position: 2,
          wegow_environment: "prod",
          wegow_section: "events-related-to-value",
          country: 1,
          id: `wegow-ads-container-` + parseInt(Math.random() * 1000)
        },
        adType: "wegow-web-event-ad",
        adClass: "wegow-web-home-event-ad"
      };
      eventsRelatedToVenue.value.splice(1, 0, cardAd);
    }
  };

  const deleteAddRelatedToVenue = id => {
    if (eventsRelatedToVenue.value.length > 0) {
      let indexDelete = eventsRelatedToVenue.value.findIndex(ad => {
        return ad.add?.id === id;
      });
      if (indexDelete !== -1) {
        eventsRelatedToVenue.value.splice(indexDelete, 1);
      }
    }
  };

  const getEventsRelatedToArtist = async (data, addAds = false) => {
    let params = {
      related_to_mag_artist: data.id,
      page_size: data.page_size || 100,
      count: true
    };
    await eventStore.getEventsRelatedToArtist(params);
    if (addAds && eventsRelatedToArtist.value.events.events.length > 1) {
      let cardAd = {
        add: {
          wegow_position: 2,
          wegow_environment: "prod",
          wegow_section: "events-related-to-artist",
          country: 1,
          id: `wegow-ads-container-` + parseInt(Math.random() * 1000)
        },
        adType: "wegow-web-event-ad",
        adClass: "wegow-web-home-event-ad"
      };
      eventsRelatedToArtist.value.events.splice(1, 0, cardAd);
    }
  };

  const deleteAddRelatedToArtist = id => {
    if (eventsRelatedToArtist.value.length > 0) {
      let indexDelete = eventsRelatedToArtist.value.findIndex(ad => {
        return ad.add?.id === id;
      });
      if (indexDelete !== -1) {
        eventsRelatedToArtist.value.splice(indexDelete, 1);
      }
    }
  };

  const getEventsRelatedToEvent = async (data, addAds = false) => {
    if (data.id) {
      let params = {
        related_to_mag_event: data.id,
        page: data.page,
        page_size: data.page_size || 100,
        count: true
      };
      await eventStore.getEventsRelatedToEvent(params);
      if (addAds && eventsRelatedToEvent.value.events.length > 1) {
        let cardAd = {
          add: {
            wegow_position: 2,
            wegow_environment: "prod",
            wegow_section: "events-related-to-event",
            country: 1,
            id: `wegow-ads-container-` + parseInt(Math.random() * 1000)
          },
          adType: "wegow-web-event-ad",
          adClass: "wegow-web-home-event-ad"
        };
        eventsRelatedToEvent.value.events.splice(1, 0, cardAd);
      }
    }
  };

  const deleteAddRelatedToEvent = id => {
    if (eventsRelatedToEvent.value.length > 0) {
      let indexDelete = eventsRelatedToEvent.value.findIndex(ad => {
        return ad.add?.id === id;
      });
      if (indexDelete !== -1) {
        eventsRelatedToEvent.value.splice(indexDelete, 1);
      }
    }
  };

  const getEventsToArtist = async (artist, data = {}) => {
    let params = {
      artists: artist.id,
      page_size: data.page_size
    };
    await eventStore.getEventsToArtist(params);
  };

  const getCityArtistEvents = async (artist, location) => {
    let params = {
      artists: artist.id,
      hl_location: location.id
    };

    await eventStore.getCityArtistEvents(params);
  };
  const getCountryEvents = async (artist, location) => {
    let params = {
      country: location.country_id,
      artists: artist.id
    };
    await eventStore.getCountryEvents(params);
  };
  const getPreviousEvents = async (artist, location) => {
    let params = {
      hl_location: location.id,
      artists: artist.id,
      ordering: "-start_date",
      processing_status: 3
    };
    await eventStore.getPreviousEvents(params);
  };

  const getEventsToVenues = async data => {
    let params = {
      venue: data.id,
      page_size: data.page_size,
      count: true
    };
    await eventStore.getEventsToVenues(params);
  };

  const getDetails = async slug => {
    // TODO: Revisar por que en ocasiones el route esta vacio (Puede que ya no)
    isIframe.value = route?.path.includes("/widget/");
    await eventStore.getDetails(slug);
  };

  const getTickets = async () => {
    let payload = {
      event: details.value.id,
      is_streaming: false // TODO: ¿La condicion?
    };
    await eventStore.getTickets(payload);
  };

  const getSeatsioTickets = async seatsioPlaces => {
    let payload = {
      event: details.value.id,
      is_streaming: false, // TODO: ¿La condicion?
      places: seatsioPlaces
    };
    await eventStore.getSeatsioTickets(payload);
  };

  const getSeatsioConfig = async seatsioPlaces => {
    let payload = {
      ticket_dist: details.value.ticket_distributions[0].id,
      places: seatsioPlaces
    };
    await eventStore.getSeatsioConfig(payload);
  };

  const hasCulturalBonus = (event, timezone) => {
    if (
      (timezone === "Europe/Madrid" ||
        timezone === "Africa/Ceuta" ||
        timezone === "Atlantic/Canary") &&
      event.city?.iso_code === "ES" &&
      !event.has_options
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getEventMedia = async ({ id }) => {
    await eventStore.getEventMedia({ event: id });
  };

  const getEventChannels = async event => {
    await eventStore.getEventChannels({ event: event.id });
  };

  return {
    //! Properties
    details,
    tickets,
    events,
    isIframe,
    media,
    channels,
    defaultChannels,
    eventsToArtist,
    eventsToArtistInCity,
    eventsToArtistInCountry,
    eventsToArtistPast,
    eventsToVenues,
    eventsRelatedToVenue,
    eventsRelatedToArtist,
    eventsRelatedToEvent,
    // Seatsio
    configSeatsio,
    minTickets,
    available,
    pair,
    // computed
    vaildMedias: computed(()=> {
      if (media.value?.length > 0) {
        return media.value.filter(m => m.type === 1 || m.thumbnails);
      } else {
        return [];
      }
    }),

    //! Metodos
    getDetails,
    getTickets,
    getEventMedia,
    getEventChannels,
    getEvents,
    getEventBySlug,
    getEventsToArtist,
    getCityArtistEvents,
    getCountryEvents,
    getPreviousEvents,
    getEventsToVenues,
    getEventsRelatedToVenue,
    getEventsRelatedToArtist,
    getEventsRelatedToEvent,
    deleteAddRelatedToVenue,
    deleteAddRelatedToArtist,
    deleteAddRelatedToEvent,
    // Seatsio
    getSeatsioConfig,
    getSeatsioTickets,
    hasCulturalBonus
  };
};
